<template>
    <div style="padding: 0 15px">
        <!-- 工具栏 -->
        <div class="filter-container">
            <el-button class="filter-item" size="small" icon="el-icon-circle-plus-outline" type="primary" @click="yonghuquanxianbtn">添加用户权限</el-button>
            <el-button class="filter-item" size="small" icon="el-icon-delete" type="danger" @click="piliangshanchuquanxian" >批量删除</el-button>
            <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width: 220px"></el-input>
        </div>

        <!-- table 列表-->
        <el-table class="grayTableTile" size="mini" ref="multipleTable" v-loading="listLoading" :row-key="getRowKeys" :data="tableList" border style="width: 100%" @sort-change="handleAgeSortChange" @selection-change="handleSelectionChange">
            <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
            <el-table-column prop="name" label="角色名称" sortable='custom'></el-table-column>
            <el-table-column prop="title" label="显示名称" sortable='custom'></el-table-column>
            <!-- <el-table-column prop="type" label="角色类型" sortable='custom'></el-table-column> -->
            <el-table-column prop="addTime" label="创建时间" sortable='custom'></el-table-column>
            <el-table-column prop="" label="操作" width="150">
                <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-danger" :disabled="!scope.row.del" @click="quanxianshanchu(scope.row)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>

         <!-- 分页 -->
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="margin-top:0;" />

    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {userdoRemoveRole} from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
export default {
    components: {Pagination},
    data() {
        return {
            search: '',
            listLoading: false,
            originalCaseTable:[],// 排序原始数据
            caseTable: [], // 存放后端一次性返回的所有数据
            handCaseTable: [], // 存放处理假分页后的数据(等距切割)
            tableData: [], // 切割后页面应展示的数据
            total: 0,
            listQuery: {
               pageNo: 1,
               pageSize: 10 
            },

            userInfo: {}, // 详情

            multipleSelection: [], // 选中
        }
    },

    computed: {
        tableList() {
            let caseTable = this.caseTable
            const search = this.search.toLowerCase().replace(/\s+/g,"");
            if(search) {
                caseTable = this.caseTable.filter(data => {
                return String(data['name']).toLowerCase().indexOf(search) > -1 
                        || String(data['title']).toLowerCase().indexOf(search) > -1
                })
            }

            this.total = caseTable.length
            // 将一维数组切割成二维数组
            this.handCaseTable = arrSlice(caseTable, this.listQuery.pageSize)
            this.tableData = this.handCaseTable[this.listQuery.pageNo-1]
            return this.tableData
        }
    },

    methods: {
        init(row, list) {
            this.userInfo = row
            this.search = ''
            this.listLoading = false
            this.tableData = []
            this.total = 0
            this.listQuery = {
               pageNo: 1,
               pageSize: 10 
            }
            this.caseTable = list
            this.originalCaseTable = JSON.parse(JSON.stringify(list))

            this.multipleSelection = []
            this.$refs.multipleTable.clearSelection();
            // console.log('初始化===')
        },


        // 排序
        handleAgeSortChange(e) {
            if(e.order) {
                const order = e.order == 'descending' ? false : true
                this.caseTable.sort(sortKeys(e.prop, order))
            } else {
                this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
            }
        },

        // 选中
        handleSelectionChange(val) {
            this.multipleSelection = val
        },

        // 设置回显的函数 当前行的数据，需要一个唯一的标识来标记是哪一个被选中了
        getRowKeys(row) {
            // console.log(row)
            return row.id
        },

        // 添加用户权限
        yonghuquanxianbtn() {
            this.$emit('handleAddRoles')
        },

        // 批量删除
        piliangshanchuquanxian() {
            if(this.multipleSelection.length > 0) {
                const ids = []
                this.multipleSelection.forEach(m => {
                    ids.push(m.id)
                });

                const data = {
                    userId: [this.userInfo.id],
                    roleId: ids
                }
                this.handleDelete(data)
            } else {
                this.$message({
                    message: "请先选择要删除的用户权限",
                    type: "error"
                });
            }

        },

        // 单个删除
        quanxianshanchu(row) {
            const data = {
                userId: [this.userInfo.id],
                roleId: [row.id]
            }
            this.handleDelete(data, row)
        },
        
        // 操作删除
        handleDelete(data, row) {
            this.$confirm( row ? '确认删除用户权限： "' + row.name + '" 吗？' : '确认删除所选权限吗？').then(_ => {
                userdoRemoveRole(data).then(response => {
                    if (response.code == 1) {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });

                        this.$emit('getAgainList')
                    }
                });
            }).catch(_ => { });
        }
    }
}
</script>